import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavParams, ModalController, NavController } from '@ionic/angular';

@Component({
  selector: 'app-show-image',
  templateUrl: './show-image.component.html',
  styleUrls: ['./show-image.component.scss'],
})
export class ShowImageComponent implements OnInit {
  @ViewChild('slider',{ read : ElementRef,static :false })slider :ElementRef;
  
  img:any;
  video:any
  audio:any;
  sliderOpts:any ={
    zoom:{
      maxRatio:3
    }
  }
  slideOptss: { initialSlide: number; speed: number; slidesPerView: number; };
  VideoURl: any;
  image:any;
  imgs: any;
  constructor(
    private navParams:NavParams,
    private modalController:ModalController,
    private navCtrl:NavController
    ) { }

  ngOnInit() {
    this.img = this.navParams.get('img');
    this.imgs = this.navParams.get('dat');
    this.video = this.navParams.get('video');
    this.audio = this.navParams.get('audio');
    this.image=this.navParams.get('data')
    this.VideoURl=this.navParams.get('datas')
    console.log(this.imgs);
  }



  close(){
    this.modalController.dismiss();
  }

  zoomin(){
    this.slider.nativeElement.swiper.zoom.in();
  }

  zoomout(){
    this.slider.nativeElement.swiper.zoom.out();
  }

  playAudio(){
    let audio = new Audio();
    audio.src = this.audio;
    audio.load();
    audio.play();
  }

  ionViewDidEnter(){
    this.slideOptss = {
      initialSlide: 0,
      speed: 200,
      slidesPerView:1,
     
    }
  }

}
